import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, useFormContext } from 'react-hook-form';
import TemplateTextarea, { type TemplateTextareaProps } from '../../template-textarea';
import FormWrapper from '../internals/form-wrapper';
export type FormTemplateTextareaProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: ControllerProps<TFieldValues>['rules'];
  hint?: string | React.ReactNode;
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal';
} & Omit<TemplateTextareaProps, 'value' | 'onBlur' | 'ref' | 'id'>;
export default function FormTemplateTextarea(t0) {
  const $ = _c(22);
  let hint;
  let inputProps;
  let label;
  let name;
  let rules;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      name,
      label,
      rules,
      hint,
      size: t1,
      errorPosition: t2,
      orientation: t3,
      ...inputProps
    } = t0);
    $[0] = t0;
    $[1] = hint;
    $[2] = inputProps;
    $[3] = label;
    $[4] = name;
    $[5] = rules;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    hint = $[1];
    inputProps = $[2];
    label = $[3];
    name = $[4];
    rules = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  const size = t1 === undefined ? "default" : t1;
  const errorPosition = t2 === undefined ? "relative" : t2;
  const orientation = t3 === undefined ? "vertical" : t3;
  const {
    control
  } = useFormContext();
  const contextId = useId();
  let t4;
  if ($[9] !== contextId || $[10] !== errorPosition || $[11] !== hint || $[12] !== inputProps || $[13] !== label || $[14] !== orientation || $[15] !== size) {
    t4 = t5 => {
      const {
        field,
        fieldState
      } = t5;
      const error = fieldState.error?.message;
      return <FormWrapper id={contextId} error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} orientation={orientation} fullWidth={true} disabled={inputProps.disabled || field.disabled}><TemplateTextarea {...inputProps} {...field} onChange={e => {
          field.onChange(e);
          inputProps.onChange?.(e);
        }} disabled={field.disabled || inputProps.disabled} data-dd-privacy="mask" size={size} hasError={!!error} /></FormWrapper>;
    };
    $[9] = contextId;
    $[10] = errorPosition;
    $[11] = hint;
    $[12] = inputProps;
    $[13] = label;
    $[14] = orientation;
    $[15] = size;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== control || $[18] !== name || $[19] !== rules || $[20] !== t4) {
    t5 = <Controller name={name} control={control} rules={rules} render={t4} />;
    $[17] = control;
    $[18] = name;
    $[19] = rules;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}